import { Widget, WIDGET_LIVEEVENTS } from "@gaming/srvg-classes-core";


export class LiveEventsWidget extends Widget {
    widgetName: string;
    widget: any;

    constructor( options ) {

        options = options || {};
        options.selector = options.selector || '#liveEventsWidget';
        super( options );

        this.name = 'widgetliveevents';
        this.widgetName = options.widgetName || WIDGET_LIVEEVENTS;
        this.widgetName = this.product + this.widgetName;

        this.widget = null;
        this.widgetOptions = {
            height: this.getContainerHeightWithUnit()
        };
        this.mergeWidgetOptions(options);
    }

    handleDomInstantiated() {
        this.addLiveEventsWidget();
        super.handleDomInstantiated();
    }

    /**
     * add live events widget to given selector (html element selector)
     * @param string selector html element selected (not element itself)
     */
    addLiveEventsWidget(selector?) {
        var that = this;
        selector = selector || this.selector;

        this.widget = this.addWidget(
            selector,
            this.widgetName,
            this.widgetOptions
        );
    }

    /**
     * add specific widget will be called by events for example, prepares eventdata and calls addLiveEventsWidget
     * @param string selector
     * @param object/any eventdata
     */
    addSpecificWidget(element, eventdata){
        this.addLiveEventsWidget(element);
    }



}
